<template>
    <div class="phone-box">
        <div class="head-box">
            <div class="head-image-box">
                <img :src="imageUrl+pet.petUrl" alt="" class="head-image">
            </div>
            <div class="head-name">{{pet.petName || "-"}}</div>
        </div>
        <div class="message" v-if="openId == pet.openId">
            <!-- <div class="message-item">
                <div class="message-title">狗证编号</div>
                <div class="message-value">{{pet.certificateNo || "-"}}</div>
            </div>
            <div class="message-item">
                <div class="message-title">疫苗信息</div>
                <div class="message-value">{{pet.vaccines || "-"}}</div>
            </div> -->
            <div class="message-item">
                <div class="message-title">疫苗状态:</div>
                <div class="message-value" :class="pet.vaccinesStatus == 1?'green':'red'">{{pet.vaccinesStatus == 1?'已打疫苗':'未打疫苗'}}</div>
                <div class="message-perfect" v-if="pet.vaccinesStatus != 1" @click="edit">完善疫苗</div>
            </div>
            <div class="message-item">
                <div class="message-title">打疫苗时间:</div>
                <div class="message-value">{{pet.vaccinationTime || "-"}}</div>
            </div>
            <!-- <div class="message-item">
                <div class="message-title">疫苗有效期</div>
                <div class="message-value">{{pet.vaccinesEffectiveTime || "-"}}</div>
            </div> -->
            <!-- <div class="message-item">
                <div class="message-title">是否办理狗证</div>
                <div class="message-value" :class="pet.isCertificate == 1?'green':'red'">{{pet.isCertificate == 1?'已办':'未办'}}</div>
            </div> -->
            <div class="message-item">
                <div class="message-title">主人姓名:</div>
                <div class="message-value">{{pet.userName || "-"}}</div>
            </div>
            <div class="message-item">
                <div class="message-title">主人电话:</div>
                <div class="message-value">{{pet.userPhone || "-"}}</div>
            </div>
            <div class="message-item">
                <div class="message-title">{{pet.isCn==1?'主人身份证号':'主人护照编号'}}:</div>
                <div class="message-value">{{showIdCard?pet.userIdCard:'**********'}}</div>
            </div>
            <div class="message-item">
                <div class="message-title">居住地址:</div>
                <div class="message-value">{{pet.userAddrss || "-"}}</div>
            </div>
            <div class="message-item">
                <div class="message-title">房产证(租房合同):</div>
                <div class="message-image__box" v-if="pet.rentalContractUrl">
                    <img :src="imageUrl+pet.rentalContractUrl" class="message-image">
                </div>
                <div class="message-perfect" v-else @click="edit">完善信息</div>
            </div>
        </div>
        <div class="pet-contact" v-else>
            <div class="pet-contact__label">主人电话</div>
            <div class="pet-contact__phone">{{pet.userPhone || "-"}}</div>
            <div class="btn-box">
                <a class="btn btn-inner" style="text-decoration:none" :href="'tel:'+pet.userPhone">拨打电话</a>
            </div>
        </div>
        <div class="btn-box" v-if="showIdCard">
            <div class="btn btn-inner" @click="edit">编辑</div>
            <div class="btn" @click="back">返回</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            userData:JSON.parse(sessionStorage.getItem("TC_PET_USERDATA")),
            showIdCard:false,
            openId:"",
            pet:{},
            imageUrl:process.env.VUE_APP_BASE_API
        }
    },
    mounted(){
        let params = this.getQueryParams()
        // if(params.showIdCard){
        //     this.showIdCard = true
        // }
        if(params.pet){
            this.pet = JSON.parse(params.pet)
            let user = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
            this.openId = user.openId
            if(this.openId == this.pet.openId){
                this.showIdCard = true
            }
        }
        
        // if(this.$route.query.showIdCard){
        //     this.showIdCard = true
        // }
        // if(this.$route.query.pet){
        //     this.pet = JSON.parse(this.$route.query.pet)
        // }
    },
    methods:{
        getQueryParams() {
            var search = window.location.search;
            var queryParams = {};
            if (search) {
                search = search.substring(1); // 去掉问号
                var params = search.split('&');
                for (var i = 0; i < params.length; i++) {
                var pair = params[i].split('=');
                var paramName = decodeURIComponent(pair[0]);
                var paramValue = decodeURIComponent(pair[1]);
                queryParams[paramName] = paramValue;
                }
            }
            return queryParams;
        },
        edit(){
            this.$router.push({path:"/petEdit",query:{pet:JSON.stringify(this.pet)}})
        },
        back(){
            this.$router.push({path:"/petList"})
        }
    }
}
</script>
<style scoped lang="less">
    .phone-box{
        width:100%;
        height: 100vh;
        overflow: auto;
        background-color: #f3f3f3;
        .head-box{
            padding:20px 0;
            background: linear-gradient(to right,#56ccf2 0%,#146de5 100%);
            .head-image-box{
                width:100px;
                height: 100px;
                margin: auto;
                border:3px solid #69e6ec;
                border-radius: 50%;
                overflow: hidden;
            }
            .head-image{
                width:100%;
            }
            .head-name{
                margin-top:15px;
                font-size: 18px;
                color:#fff;
                text-align: center;
            }
        }
        .message{
            margin-top:15px;
            .message-item{
                display: flex;
                flex-direction: row;
                // justify-content: space-between;
                padding:8px 15px;
                margin-bottom:1px;
                background-color: #fff;
            }
            .message-title{
                flex:0 0 115px;
                color:#777;
                font-size: 14px;
            }
            .message-value{
                margin-left:15px;
                color:#333;
                font-size: 14px;
                // text-align: right;
            }
            .message-image__box{
                width:100px;
                height: 100px;
                overflow: hidden;
                margin-left:15px;
                border-radius: 3px;
            }
            .message-image{
                width:100%;
            }
            .message-perfect{
                margin-left:15px;
                color:#333;
                font-size: 14px;
                text-decoration: underline;
            }
        }
        .btn-box{
            display: flex;
            flex-direction: row;
            gap:10px;
            padding:0 20px;
            margin:20px 0;
            .btn{
                flex:1;
                padding:8px 25px;
                color:#317aed;
                font-size: 14px;
                border:1px solid #317aed;
                background-color: #fff;
                text-align: center;
                border-radius: 3px;
            }
            .btn-inner{
                background: #317aed;
                color:#fff;
            }
        }
    }
    .pet-contact{
        display: flex;
        flex-direction: column;
        align-items: center;
        .pet-contact__label{
            font-size: 17px;
            margin-top: 15px;
        }
        .pet-contact__phone{
            font-size: 15px;
            margin-top: 10px;
        }
    }
    .green{
        color: green !important;
    }
    .red{
        color:red!important;
    }
</style>